import { pr, theme, ui } from "aaa";
import * as React from "react";
import { CardWithIcon } from "./CardWithIcon";
import { NativeIconButton } from "./NativeIconButton";
import { NativeModal } from "./NativeModal";
import { NativeTooltip } from "./NativeTooltip";

const BUTTON_SIZE = 24;
const DIALOG_HEIGHT = 400;


type CardWithIconAndTextAndTooltipProps = {
    "aria-label"?: string,
    checked: boolean,
    hoverText?: string,
    icon: string | React.ReactNode,
    isMobile?: boolean,
    text: string,
    width?: number,
    onClick: any,
};

export const CardWithIconAndTextAndTooltip = ({
    "aria-label": ariaLabel,
    checked,
    hoverText = "",
    icon,
    isMobile,
    text,
    width = 190,
    onClick,
}: CardWithIconAndTextAndTooltipProps) => {
    const tooltipRef = React.useRef<HTMLDivElement>(null);
    const [isOpen, setIsOpen] = React.useState(false);
    const color = checked ? theme.customColors.georgeLightBlue : theme.customColors.georgeLightGrey;

    const handleMouseOver = () => {
        ui.isPopupVisible = true;
        setIsOpen(true);
    }

    const handleMouseOut = () => {
        ui.isPopupVisible = false;
        setIsOpen(false);
    }

    const handleClick = (event: React.MouseEvent) => {
        event.stopPropagation();
        ui.isPopupVisible = true;
        setIsOpen(true);
    }

    const handleCloseModal = () => {
        ui.isPopupVisible = false;
        setIsOpen(false);
    }

    return (
        <>
            <pr.A11yPopupHider>
                <CardWithIcon
                    checked={checked}
                    onClick={onClick}
                    aria-label={ariaLabel}
                    style={{ height: 135, width: width }}
                    icon={(
                        <>
                            <div style={{ textAlign: "center" }}>
                                {typeof icon === "string" ? (
                                    <pr.GeorgeIconWrapper
                                        color={color}
                                        size={48}
                                        iconName={icon}
                                    />) : icon}
                                <pr.P_14_CONTENT style={{ marginTop: theme.MARGIN_SMALL, userSelect: "none", color }} >
                                    {text}
                                </pr.P_14_CONTENT>
                            </div>
                            {hoverText.trim().length > 0 &&
                                <>
                                    {isMobile ? (
                                        <NativeIconButton
                                            aria-label={ui.__("common.information")}
                                            disabled={!isMobile}
                                            focusStyle={{ borderRadius: 4 }}
                                            style={{
                                                height: BUTTON_SIZE,
                                                left: 10,
                                                position: "absolute",
                                                top: 10,
                                                width: BUTTON_SIZE,
                                            }}
                                            onClickWithEvent={handleClick}
                                        >
                                            <pr.IconInfoCircleHollow
                                                style={{
                                                    color: theme.customColors.georgeLightGrey,
                                                }}
                                            />
                                        </NativeIconButton>
                                    ) : (
                                            <div
                                                ref={tooltipRef}
                                                style={{
                                                    cursor: "help",
                                                    left: 10,
                                                    position: "absolute",
                                                    top: 10,
                                                }}
                                                onMouseOver={handleMouseOver}
                                                onMouseOut={handleMouseOut}
                                            >
                                                <pr.IconInfoCircleHollow
                                                    style={{
                                                        color: theme.customColors.georgeLightGrey,
                                                    }}
                                                />
                                            </div>
                                        )}
                                </>
                            }
                        </>
                    )}
                />
            </pr.A11yPopupHider>
            {!isMobile ?
                <NativeTooltip
                    anchorEl={tooltipRef.current}
                    content={hoverText}
                    open={isOpen}
                    placement="top"
                />
                :
                <NativeModal
                    open={isOpen}
                    paperStyle={{ borderRadius: theme.BORDER_RADIUS }}
                    bodyStyle={{ padding: 16 }}
                    contentStyle={{
                        height: DIALOG_HEIGHT,
                        maxWidth: theme.MAX_APP_WIDTH,
                        // Override the default transform to slide up from the bottom
                        // per George explicit request.
                        transform: isOpen ? "translate(0, 64px)" : "translate(0, 100vh)",
                        width: "95%",
                    }}
                >
                    <div
                        style={{
                            alignItems: "start",
                            display: "flex",
                            height: "100",
                            justifyContent: "space-between",
                            width: "100%"
                        }}
                    >
                        <div
                            style={{
                                alignItems: "start",
                                display: "flex",
                                gap: 8,
                                height: "100",
                                width: "100%"
                            }}
                        >
                            <pr.IconInfoCircleHollow
                                style={{
                                    color: theme.customColors.georgeLightGrey,
                                    fontSize: 18,
                                    flexShrink: 0,
                                }}
                            />
                            <div>
                                <pr.P_18_TITLE>
                                    {text}
                                </pr.P_18_TITLE>
                                <pr.P_14_CONTENT style={{ lineHeight: "20px", marginTop: 4 }}>
                                    {hoverText}
                                </pr.P_14_CONTENT>
                            </div>
                        </div>
                        <NativeIconButton
                            aria-label={ui.__("common.close")}
                            onClick={handleCloseModal}
                            focusStyle={{ borderRadius: 4 }}
                            style={{
                                height: BUTTON_SIZE,
                                width: BUTTON_SIZE,
                            }}
                        >
                            <pr.IconClose
                                style={{
                                    color: theme.customColors.georgeLightGrey,
                                }}
                            />
                        </NativeIconButton>
                    </div>
                </NativeModal>
            }
        </>
    );
};


// WEBPACK FOOTER //
// ./src/components/common/CardWithIconAndTextAndTooltip.tsx